export const translations = {
  en: {
    // Navigation
    nav_home: "Home",
    nav_book: "Book Now",
    nav_shop: "Shop",
    nav_gallery: "Gallery",
    nav_profile: "Profile",
    nav_login: "Login",
    nav_logout: "Logout",
    
    // Hero
    hero_title: "Arabian Barber",
    hero_subtitle: "Modern Barbershop",
    hero_description: "Experience the art of traditional grooming with a modern touch in the heart of Nottingham",
    hero_cta: "Book Now",
    
    // Services
    services_title: "Our Services",
    services_subtitle: "Premium grooming services tailored to your needs",
    service_haircut: "Haircut",
    service_beard: "Beard Trim",
    service_steam: "Face Steam",
    service_treatment: "Hair Treatment",
    service_hair_colour: "Hair Colour",
    service_beard_colour: "Beard Colour",
    service_facemask: "Face Mask & Skin Care",
    service_zero: "Zero Haircut",
    
    // Booking
    booking_title: "Book Your Appointment",
    booking_select_services: "Select Services",
    booking_select_date: "Select Date",
    booking_select_time: "Select Time",
    booking_your_details: "Your Details",
    booking_confirm: "Confirm Booking",
    booking_name: "Full Name",
    booking_email: "Email",
    booking_phone: "Phone Number",
    booking_notes: "Notes (optional)",
    booking_success: "Booking Confirmed!",
    booking_pending: "Pending Confirmation",
    
    // Shop
    shop_title: "Shop",
    shop_subtitle: "Premium grooming products",
    shop_add_cart: "Add to Cart",
    shop_categories: "Categories",
    shop_all: "All Products",
    shop_hair_cream: "Hair Creams",
    shop_cologne: "Colognes",
    shop_beard_oil: "Beard Oils",
    
    // Cart
    cart_title: "Your Cart",
    cart_empty: "Your cart is empty",
    cart_total: "Total",
    cart_checkout: "Checkout",
    cart_remove: "Remove",
    cart_quantity: "Quantity",
    
    // Checkout
    checkout_title: "Checkout",
    checkout_payment_method: "Payment Method",
    checkout_card: "Pay by Card",
    checkout_cash: "Pay Cash on Collection",
    checkout_transfer: "Bank Transfer",
    checkout_place_order: "Place Order",
    checkout_success: "Order Placed Successfully!",
    
    // Profile
    profile_title: "My Profile",
    profile_bookings: "My Bookings",
    profile_orders: "My Orders",
    profile_loyalty: "Loyalty Points",
    profile_points: "points",
    profile_no_bookings: "No bookings yet",
    profile_no_orders: "No orders yet",
    
    // Auth
    auth_login: "Login",
    auth_register: "Register",
    auth_email: "Email",
    auth_password: "Password",
    auth_name: "Full Name",
    auth_phone: "Phone Number",
    auth_already_have: "Already have an account?",
    auth_dont_have: "Don't have an account?",
    
    // Gallery
    gallery_title: "Our Work",
    gallery_subtitle: "See the quality of our craftsmanship",
    
    // Contact
    contact_title: "Contact Us",
    contact_address: "Address",
    contact_phone: "Phone",
    contact_email: "Email",
    contact_hours: "Opening Hours",
    contact_mon_sat: "Mon - Sat: 10am - 10pm",
    contact_sunday: "Sunday: 10am - 7pm",
    
    // Footer
    footer_copyright: "© 2024 Arabian Barber. All rights reserved.",
    footer_address: "61 Maid Marian Way, Nottingham NG1 6AJ",
    
    // Common
    common_loading: "Loading...",
    common_error: "An error occurred",
    common_success: "Success!",
    common_cancel: "Cancel",
    common_save: "Save",
    common_delete: "Delete",
    common_edit: "Edit",
    common_back: "Back",
    common_next: "Next",
    common_close: "Close",
    common_submit: "Submit",
    
    // Admin
    admin_title: "Admin Panel",
    admin_bookings: "Bookings",
    admin_products: "Products",
    admin_orders: "Orders",
    admin_gallery: "Gallery",
    admin_loyalty: "Loyalty",
    admin_services: "Services",
    admin_password: "Enter Admin Password",
    admin_login: "Login",
    
    // Status
    status_pending: "Pending",
    status_confirmed: "Confirmed",
    status_completed: "Completed",
    status_cancelled: "Cancelled",
    status_paid: "Paid",
    status_processing: "Processing",
    status_delivered: "Delivered",
  },
  ar: {
    // Navigation
    nav_home: "الرئيسية",
    nav_book: "احجز الآن",
    nav_shop: "المتجر",
    nav_gallery: "معرض الصور",
    nav_profile: "حسابي",
    nav_login: "تسجيل الدخول",
    nav_logout: "تسجيل الخروج",
    
    // Hero
    hero_title: "الحلاق العربي",
    hero_subtitle: "صالون حلاقة عصري",
    hero_description: "اختبر فن الحلاقة التقليدية بلمسة عصرية في قلب نوتنغهام",
    hero_cta: "احجز الآن",
    
    // Services
    services_title: "خدماتنا",
    services_subtitle: "خدمات حلاقة فاخرة مصممة لاحتياجاتك",
    service_haircut: "قص شعر",
    service_beard: "تشذيب اللحية",
    service_steam: "بخار الوجه",
    service_treatment: "علاج الشعر",
    service_hair_colour: "صبغة الشعر",
    service_beard_colour: "صبغة اللحية",
    service_facemask: "قناع الوجه والعناية بالبشرة",
    service_zero: "حلاقة صفر",
    
    // Booking
    booking_title: "احجز موعدك",
    booking_select_services: "اختر الخدمات",
    booking_select_date: "اختر التاريخ",
    booking_select_time: "اختر الوقت",
    booking_your_details: "بياناتك",
    booking_confirm: "تأكيد الحجز",
    booking_name: "الاسم الكامل",
    booking_email: "البريد الإلكتروني",
    booking_phone: "رقم الهاتف",
    booking_notes: "ملاحظات (اختياري)",
    booking_success: "تم تأكيد الحجز!",
    booking_pending: "في انتظار التأكيد",
    
    // Shop
    shop_title: "المتجر",
    shop_subtitle: "منتجات العناية الفاخرة",
    shop_add_cart: "أضف للسلة",
    shop_categories: "الفئات",
    shop_all: "جميع المنتجات",
    shop_hair_cream: "كريمات الشعر",
    shop_cologne: "العطور",
    shop_beard_oil: "زيوت اللحية",
    
    // Cart
    cart_title: "سلة التسوق",
    cart_empty: "السلة فارغة",
    cart_total: "المجموع",
    cart_checkout: "الدفع",
    cart_remove: "إزالة",
    cart_quantity: "الكمية",
    
    // Checkout
    checkout_title: "إتمام الطلب",
    checkout_payment_method: "طريقة الدفع",
    checkout_card: "الدفع بالبطاقة",
    checkout_cash: "الدفع نقداً عند الاستلام",
    checkout_transfer: "تحويل بنكي",
    checkout_place_order: "تأكيد الطلب",
    checkout_success: "تم الطلب بنجاح!",
    
    // Profile
    profile_title: "حسابي",
    profile_bookings: "حجوزاتي",
    profile_orders: "طلباتي",
    profile_loyalty: "نقاط الولاء",
    profile_points: "نقطة",
    profile_no_bookings: "لا توجد حجوزات",
    profile_no_orders: "لا توجد طلبات",
    
    // Auth
    auth_login: "تسجيل الدخول",
    auth_register: "إنشاء حساب",
    auth_email: "البريد الإلكتروني",
    auth_password: "كلمة المرور",
    auth_name: "الاسم الكامل",
    auth_phone: "رقم الهاتف",
    auth_already_have: "لديك حساب بالفعل؟",
    auth_dont_have: "ليس لديك حساب؟",
    
    // Gallery
    gallery_title: "أعمالنا",
    gallery_subtitle: "شاهد جودة أعمالنا",
    
    // Contact
    contact_title: "تواصل معنا",
    contact_address: "العنوان",
    contact_phone: "الهاتف",
    contact_email: "البريد الإلكتروني",
    contact_hours: "ساعات العمل",
    contact_mon_sat: "الإثنين - السبت: 10ص - 10م",
    contact_sunday: "الأحد: 10ص - 7م",
    
    // Footer
    footer_copyright: "© 2024 الحلاق العربي. جميع الحقوق محفوظة.",
    footer_address: "61 طريق ميد ماريان، نوتنغهام NG1 6AJ",
    
    // Common
    common_loading: "جاري التحميل...",
    common_error: "حدث خطأ",
    common_success: "تم بنجاح!",
    common_cancel: "إلغاء",
    common_save: "حفظ",
    common_delete: "حذف",
    common_edit: "تعديل",
    common_back: "رجوع",
    common_next: "التالي",
    common_close: "إغلاق",
    common_submit: "إرسال",
    
    // Admin
    admin_title: "لوحة الإدارة",
    admin_bookings: "الحجوزات",
    admin_products: "المنتجات",
    admin_orders: "الطلبات",
    admin_gallery: "المعرض",
    admin_loyalty: "نقاط الولاء",
    admin_services: "الخدمات",
    admin_password: "أدخل كلمة مرور المدير",
    admin_login: "دخول",
    
    // Status
    status_pending: "في الانتظار",
    status_confirmed: "مؤكد",
    status_completed: "مكتمل",
    status_cancelled: "ملغي",
    status_paid: "مدفوع",
    status_processing: "قيد المعالجة",
    status_delivered: "تم التوصيل",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.en[key] || key;
};
